import { EmptyPageLoader } from 'components/Loader'
import useAuth from 'contexts/auth'
import useApi from 'hooks/useApi'
import { LayoutBlackWithLogo } from 'routes/components/LayoutBlackWithLogo'

import { OrgProvider } from './Orgs/org-context'
import { ManageTrial } from './Workspaces/ManageTrial'

export function RequiredAuthWrapper({ children }) {
  const { loading, self, login } = useAuth()
  const { getImpersonationToken } = useApi()

  if (loading) {
    return <EmptyPageLoader />
  }

  if (!self?.user) {
    void login()
    return <EmptyPageLoader />
  }

  const hasOrgs = self.orgs?.length
  const hasNonTrialOrgs = self.orgs?.some(
    (org) => !org.trialEndDate || new Date(org.trialEndDate) >= new Date(),
  )

  const isImpersonating = !!getImpersonationToken()
  if (hasOrgs && !hasNonTrialOrgs && !isImpersonating) {
    return (
      <LayoutBlackWithLogo>
        <OrgProvider orgId={self?.workspace?.orgId}>
          <ManageTrial />
        </OrgProvider>
      </LayoutBlackWithLogo>
    )
  }

  return <>{children}</>
}
